/** Gravity scale as fraction of 9.81 m/s². 1 = real gravity, 0.15 = 15% (slow motion). */
export const GRAVITY_SCALE = 1.0
